import {
  GetLaunchWorkflowsByRequesterInput,
  LaunchWorkflowData,
} from "@amzn/coral_com-amazon-deviceslaunchcontrolservice";
import { AppThunk } from "../app/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getLaunchWorkflowsByRequester } from "../app/api";

interface OclSubmissionToolsState {
  items: LaunchWorkflowData[];
  isGettingLaunchWorkflowsForUser: boolean;
}

const OclSubmissionToolsInitialState: OclSubmissionToolsState = {
  items: [],
  isGettingLaunchWorkflowsForUser: true,
};

const oneClickLaunchSubmissionToolsControl = createSlice({
  name: "oneClickLaunchSubmissionToolsControl",
  initialState: OclSubmissionToolsInitialState,
  reducers: {
    setGettingLaunchWorkflowsForUser(state, action: PayloadAction<boolean>) {
      state.isGettingLaunchWorkflowsForUser = action.payload;
    },
    setItemsForUser(state, action: PayloadAction<LaunchWorkflowData[]>) {
      state.items = action.payload;
    },
  },
});

export const { setGettingLaunchWorkflowsForUser, setItemsForUser } =
  oneClickLaunchSubmissionToolsControl.actions;

export default oneClickLaunchSubmissionToolsControl.reducer;

export const fetchLaunchWorkflowsByRequester =
  (input: GetLaunchWorkflowsByRequesterInput): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setGettingLaunchWorkflowsForUser(true));
      const result = await getLaunchWorkflowsByRequester(input);
      dispatch(setItemsForUser(result.results as LaunchWorkflowData[]));
      dispatch(setGettingLaunchWorkflowsForUser(false));
    } catch (err: any) {
      dispatch(setGettingLaunchWorkflowsForUser(false));
      console.log(err);
    }
  };
